import {
  SUPPORT_SET_SHEET_OPEN,
  SUPPORT_SET_SHEET_CLOSE,
  SUPPORT_SET_SHEET_ARTICLE_ID,
  useSupport,
  useSupportDispatch,
} from "../SupportContext";

export function useSupportSheet() {
  const dispatch = useSupportDispatch();

  const { isSheetOpen, sheetArticleId } = useSupport();

  const openSheet = (articleId: string) => {
    dispatch({ type: SUPPORT_SET_SHEET_OPEN, payload: { articleId } });
  };

  const closeSheet = () => {
    dispatch({ type: SUPPORT_SET_SHEET_CLOSE });
  };

  const setSheetArticleId = (articleId: string) => {
    dispatch({ type: SUPPORT_SET_SHEET_ARTICLE_ID, payload: { articleId } });
  };

  return {
    isSheetOpen,
    sheetArticleId,
    openSheet,
    closeSheet,
    setSheetArticleId,
  };
}

export default useSupportSheet;
